module.exports = __webpack_public_path__ + "images/assets/013eee1b76f5faed3ad67b2ce19299e8.svg";